import { BrowserMultiFormatReader, BarcodeFormat } from '@zxing/library';
import Quagga from '@devicemagic/quagga2';

const QUAGGA_READERS = [
  'code_128_reader',
  'ean_reader',
  'ean_8_reader',
  'code_39_reader',
  'code_39_vin_reader',
  'codabar_reader',
  'upc_reader',
  'upc_e_reader',
  'i2of5_reader',
  '2of5_reader',
  'code_93_reader',
];

// Default ZXIng reader
const codeReader = new BrowserMultiFormatReader();

export const formats1D = [
  BarcodeFormat.UPC_A,
  BarcodeFormat.UPC_E,
  BarcodeFormat.EAN_8,
  BarcodeFormat.EAN_13,
  BarcodeFormat.CODE_39,
  BarcodeFormat.CODE_128,
  BarcodeFormat.CODE_93,
  BarcodeFormat.CODABAR,
  BarcodeFormat.ITF,
  BarcodeFormat.RSS_14,
  BarcodeFormat.RSS_EXPANDED,
  BarcodeFormat.UPC_EAN_EXTENSION,
];

export const formatsDL = [BarcodeFormat.PDF_417];

const useBarcodeScan = () => {
  /**
   * @param {string} base64Image
   */
  const barcodeFromImage = async (base64Image) => {
    try {
      const zxingResult = await codeReader.decodeFromImageUrl(base64Image);
      return {
        text: zxingResult.text,
        is1DCode: formats1D.includes(zxingResult.format),
        isDriverLicenseCode: formatsDL.includes(zxingResult.format),
      };
    } catch (err) {
      const quaggaResult = await quaggaScanFromImage(base64Image);

      if (quaggaResult.codeResult.code) {
        return {
          text: quaggaResult.codeResult.code,
          is1DCode: true,
          resultCoords: quaggaResult.box,
        };
      }

      throw new Error('Barcode not found');
    }
  };

  const quaggaScanFromImage = (src) => {
    return new Promise((resolve, reject) => {
      Quagga.decodeSingle(
        {
          decoder: {
            readers: QUAGGA_READERS,
          },
          src,
        },
        function (result) {
          if (result?.codeResult) {
            resolve(result);
          } else {
            reject(new Error('Barcode not detected by quagga'));
          }
        }
      );
    });
  };

  /**
   *
   * @param {object} stream
   * @returns
   */
  const barcodeFromCameraStream = (stream) => {
    return new Promise((resolve) => {
      codeReader.decodeFromStream(stream, undefined, (result) => {
        if (result) {
          resolve(result);
          codeReader.reset();
        }
      });
    });
  };

  return { barcodeFromImage, barcodeFromCameraStream };
};

export default useBarcodeScan;
